import * as React from 'react'
import { SearchIcon } from 'lucide-react'
import { cn } from '../../lib/utils'
import { Input } from './input'

export interface SearchInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
	wrapperClassName?: string
}

const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
	({ className, wrapperClassName, ...props }, ref) => (
		<div className={cn('relative', wrapperClassName)}>
			<SearchIcon
				className="pointer-events-none absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-(--color-muted-foreground)"
			/>
			<Input
				ref={ref}
				type="search"
				data-slot="search-input"
				className={cn('h-8 pl-8 text-sm', className)}
				{...props}
			/>
		</div>
	)
)

SearchInput.displayName = 'SearchInput'
export { SearchInput }
